import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const More = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.9167 35.4167H27.0833V27.0833H35.4167V22.9167H27.0833V14.5833H22.9167V22.9167H14.5833V27.0833H22.9167V35.4167ZM10.4167 43.75C9.27083 43.75 8.28993 43.342 7.47396 42.526C6.65799 41.7101 6.25 40.7292 6.25 39.5833V10.4167C6.25 9.27083 6.65799 8.28993 7.47396 7.47396C8.28993 6.65799 9.27083 6.25 10.4167 6.25H39.5833C40.7292 6.25 41.7101 6.65799 42.526 7.47396C43.342 8.28993 43.75 9.27083 43.75 10.4167V39.5833C43.75 40.7292 43.342 41.7101 42.526 42.526C41.7101 43.342 40.7292 43.75 39.5833 43.75H10.4167ZM10.4167 39.5833H39.5833V10.4167H10.4167V39.5833Z"
        fill={color}
      />
    </svg>
  )
}
